import { ToastType } from '@components/toast';
import { QuoteCustomerUserPostRequestBody, QuoteCustomerUserPostResponse } from '@lio/api-types';
import { useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { getApiErrorMessage } from '@utils/getApiErrorMessage';
import { useSnackbar } from 'notistack';

export const useCreateQuoteCustomerInviteByEmail = () => {
  const client = useClient();

  const { enqueueSnackbar } = useSnackbar();

  const result = useMutation({
    mutationFn: async (requestBody: QuoteCustomerUserPostRequestBody) =>
      client
        .post(`quote-customer-user`, {
          json: requestBody,
        })
        .json<QuoteCustomerUserPostResponse>(),
    onSuccess: (data) => {
      return data;
    },
    onError: async (e) => {
      const message = await getApiErrorMessage(
        e,
        'An error occurred while adding the user. Please reach out to LIO Support for assistance.',
      );
      enqueueSnackbar(message, {
        variant: ToastType.Error,
      });

      if (message === 'User not found') {
        throw Error('User not found');
      }

      return null;
    },
  });
  return { ...result, createQuoteCustomerInviteByEmail: result.mutateAsync };
};
